// components/FAQAccordion.tsx
import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface FAQItem {
    question: string;
    answer: string;
}

const faqList: FAQItem[] = [
    { question: "O curso é presencial?", answer: "Sim. Para uma melhor experiência de aprendizado, o curso será presencial." },
    { question: "Onde será o curso?", answer: "O local do curso será no ITC Jardins – São Paulo." },
    { question: "Qual será a duração do curso?", answer: "2 dias de imersão." },
    { question: "Quando será o curso?", answer: "11 e 12 de julho de 2025." },
    { question: "Como funciona a minha inscrição?", answer: "Preencha o formulário e fale com nossa equipe de atendimento." },
    { question: "Terei certificado no final do curso?", answer: "Sim. No final da programação realizaremos a entrega dos certificados." }
];

const FAQAccordion: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggle = (index: number) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };

    return (
        <div className="max-w-[70%] mx-auto p-4">
            <h1 className="text-2xl font-bold text-center mb-6 text-white md:text-5xl lg:text-5xl">Dúvidas frequentes sobre o curso</h1>
            <div className="space-y-4">
                {faqList.map((item, index) => (
                    <div>
                        <div key={index} className="bg-white rounded-full">
                            <button
                                className="w-full flex justify-between items-center p-4 text-left focus:outline-none"
                                onClick={() => toggle(index)}
                            >
                                <span className="font-light">{item.question}</span>
                                {openIndex === index ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                            </button>
                        </div>
                        <div>
                            {openIndex === index && (
                                <div className="p-4 transition-all duration-300 font-light">
                                    <p>{item.answer}</p>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}


export default FAQAccordion;